import banks from "./banks";
export default banks;
